import { ref } from '@nuxtjs/composition-api'
import { IAppWarmup } from './app.types'

export const appLoading = ref(true)
export const appWarmup = ref<IAppWarmup | null>(null)
